// Generated by purs version 0.14.4
import * as Data_Bounded from "../Data.Bounded/index.js";
import * as Data_Enum from "../Data.Enum/index.js";
import * as Data_Unfoldable1 from "../Data.Unfoldable1/index.js";
var allEnumValues = function (dictBounded) {
    return function (dictEnum) {
        return Data_Enum.enumFromTo(dictEnum)(Data_Unfoldable1.unfoldable1Array)(Data_Bounded.bottom(dictBounded))(Data_Bounded.top(dictBounded));
    };
};
export {
    allEnumValues
};
//# sourceMappingURL=index.js.map
